import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet('regions');

export function useRegionListQuery() {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.regionsList();
      return data;
    },
    queryKey: keys.list(),
  });
}
